import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { TextField as MaterialUITextField } from '@material-ui/core';

const styles = () => ({
  inputMultiline: {
    boxShadow: 'none',
    height: '100px',
  },
  formControl: {
    marginTop: 0,
    '& input': { // overrides scss styling that gives certain inputs a green bottom-border
      borderBottom: 'none !important',
    },
  },
});

const TextField = (props) => {
  const {
    id,
    label,
    placeholder,
    helperText,
    name,
    onChange,
    onKeyPress,
    variant,
    onFocus,
    onBlur,
    value,
    required,
    type,
    classes,
    multiline,
    inputProps,
    ...rest
  } = props;

  const inputPropsWithStyles = multiline
    ? { ...inputProps, className: classes.inputMultiline }
    : inputProps;

  return (
    <MaterialUITextField
      className={classes.formControl}
      id={id}
      label={label}
      value={value}
      name={name}
      onChange={onChange}
      onFocus={onFocus}
      onBlur={onBlur}
      onKeyPress={onKeyPress}
      placeholder={placeholder}
      helperText={helperText}
      fullWidth
      margin="normal"
      variant={variant}
      type={type}
      required={required}
      multiline={multiline}
      InputLabelProps={{
        shrink: true,
      }}
      inputProps={inputPropsWithStyles}
      {...rest}
    />
  );
};

TextField.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  helperText: PropTypes.string,
  onChange: PropTypes.func,
  onKeyPress: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.string,
  required: PropTypes.bool,
  type: PropTypes.string,
  multiline: PropTypes.bool,
  inputProps: PropTypes.object,
  classes: PropTypes.object.isRequired,
  variant: PropTypes.string,
};

TextField.defaultProps = {
  label: '',
  helperText: '',
  name: '',
  placeholder: '',
  required: false,
  multiline: false,
  inputProps: {},
  type: '',
  value: '',
  variant: 'outlined',
  onBlur: () => {},
  onChange: () => {},
  onFocus: () => {},
  onKeyPress: () => {},
};

export default withStyles(styles)(TextField);
